/**
 * Toast
 * @requires https://getbootstrap.com
*/

import { Toast } from "bootstrap";

const toast = (() => {

  let toastElList = [].slice.call(document.querySelectorAll('.toast'));

  let toastList = toastElList.map((toastEl) => new Toast(toastEl));

})();

export default toast;
